import { CircleTextPercentageSignWrapper, CircleTextPercentageWrapper } from './styles';

type PercentageProps = {
  value: number;
};

const Percentage = ({ value }: PercentageProps) => {
  return (
    <>
      <CircleTextPercentageWrapper x="50%" y="52%">
        {value}
      </CircleTextPercentageWrapper>
      <CircleTextPercentageSignWrapper x={value === 100 ? '26' : '23.5'} y="13.5">
        %
      </CircleTextPercentageSignWrapper>
    </>
  );
};

export default Percentage;
